import { create } from 'zustand';
import { UserApi } from '../api/userApi';
import { Project } from '../models/project';
import { User } from '../models/user';
import { PromiseSnapshot, PromiseState } from '../utilities/promiseSnapshot';

interface ProjectUsersState {
  snapshots: Record<Project['id'], PromiseSnapshot<User[]>>;
  fetch: (projectId: Project['id']) => Promise<void>;
  getSnapshot: (projectId: Project['id']) => PromiseSnapshot<User[]>;
}

export const useProjectUsersStore = create<ProjectUsersState>((set, get) => ({
  snapshots: {},
  getSnapshot(projectId) {
    return get().snapshots[projectId] ?? new PromiseSnapshot<User[]>();
  },
  async fetch(projectId) {
    const currentSnapshot = get().snapshots[projectId];
    const initialState = currentSnapshot?.state;

    if (
      initialState === PromiseState.Failed ||
      initialState === PromiseState.NotStarted ||
      !currentSnapshot
    ) {
      await PromiseSnapshot.trackPromiseSetter(
        () => new UserApi().getAll({ admin_and_project_id: projectId }),
        (snapshot) => {
          set((state) => ({
            snapshots: {
              ...state.snapshots,
              [projectId]: snapshot,
            },
          }));
        }
      );
    }
  },
}));
